<template>
    <div>
        <div class="filter mt1x">
			<div class="tableSys mb1x vaM_E">
				<div class="pl1x dpIB_E vaM_E">
					<Select :name="'instructionsStatus'" :class="{'sizeS':true}" :list="instructionsStatusList" @Click="instructionsStatusSelect" :keyMap="{text:'name',value:'value'}"></Select>
				</div>
			</div>
		</div>
        <div class="tableScope bgContent">
			<div class="table table-5x tra-fast posR" fillHeight="lastHeight,-.myListHeight01">
				<Loading ref="loading"></Loading>
				<div id="updateRecordList" class="cb" v-show="list.length > 0">
					<div class="scrollHide tra-fast fL"
						:style="{'width':'16em'}"
						scrollFloatX="false" fillHeight="lastHeight,-.myListHeight01">
						<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
							<div class="pl2x-imp sequence" :class="{cMain:orderProperty==3}" :title="$t('device_management38',['升级时间'])" @click="order(2)">
								<span>{{$t('device_management38',['升级时间'])}}</span>
								<span :sequence="orderProperty==2 ? orderedsc : ''"></span>
							</div>
						</div>
						<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.myListHeight01" scroll="{'group':'a'}">
							<table>
								<thead class="head-token">
									<tr>
										<th></th>
									</tr>
								</thead>
								<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
									<tr v-for="(record,index) in list" :key="index" @click.stop="view()">
										<td class="pl2x-imp" :title="record.createTime?timeFormat(record.createTime/1000,'utc','%Y/%m/%d %H:%M:%S UTC',{offset:timezone}):'--'">
											<div>{{record.createTime?timeFormat(record.createTime/1000,'utc','%H:%M:%S',{offset:timezone}):'--'}}</div>
											<div class="cSub">{{record.createTime?timeFormat(record.createTime/1000,'utc','%Y/%m/%d UTC',{offset:timezone}):'--'}}</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div scroll="{'axis':'x'}">
						<div class="tableSys head noSelect b cField bdLight-bottom"
							:style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
							scrollFloatY="false">
                       		<div :title="$t('device_management101',['固件包名称'])">{{$t('device_management101',['固件包名称'])}}</div>
							<div :title="$t('word1510',['目标版本号'])">{{$t('word1510',['目标版本号'])}}</div>
							<div :title="$t('device223',['关联版本信息'])">{{$t('device223',['关联版本信息'])}}</div>
							<div :title="$t('word1513',['升级状态'])">{{$t('word1513',['升级状态'])}}</div>
              <div :title="$t('task38',['解析结果'])">{{$t('task38',['解析结果'])}}</div>
              <div style='overflow:inherit' :title="$t('task39',['失败原因'])">{{$t('task39',['失败原因'])}}<Help :code="'reasonFailureDetail'"
                    :btnClose="false"
                    class="ml05x"></Help></div>
							<div :title="$t('word788',['操作人'])">{{$t('word788',['操作人'])}}</div>
							<div :class="{cMain:orderProperty==3}" class="sequence" :title="getLanguageStr('plant56','反馈时间')" @click="order(3)">
								<span>{{getLanguageStr('plant56','反馈时间')}}</span>
								<span :sequence="orderProperty==3 ? orderedsc : ''"></span>
							</div>
						</div>
						<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.myListHeight01" scroll="{'group':'a'}">
							<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
								<thead class="head-token">
									<tr>
										<th></th>
										<th></th>
										<th></th>
										<th></th>
										<th></th>
										<th></th>
                    <th></th>
										<th></th>
									</tr>
								</thead>
								<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
									<tr v-for="(record,index) in list" :key="index">
                               			<td>{{record.firmwareName || '--'}}</td>
										<td>{{record.version || '--'}}</td>
										<td>{{record.versionKeyName || '--'}}</td>
										<td>{{record.status?getTypeText(record.status,'deviceOrderStatus'):'--'}}</td>
                    <td>{{record.analysisResult?record.analysisResult:'--'}}</td>
                    <td>{{record.error ? getTypeText(record.error,'errorReason') :'--'}}</td>
										<td>{{record.createByName || '--'}}</td>
										<td :title="record.updateTime?timeFormat(record.updateTime/1000,'utc','%Y/%m/%d %H:%M:%S UTC',{offset:timezone}):'--'">
											<div>{{record.updateTime?timeFormat(record.updateTime/1000,'utc','%H:%M:%S',{offset:timezone}):'--'}}</div>
											<div class="cSub">{{record.updateTime?timeFormat(record.updateTime/1000,'utc','%Y/%m/%d UTC',{offset:timezone}):'--'}}</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<no-result v-show="list.length == 0"></no-result>
			</div>
			<div class="tableBatch bgContent cSub tra-fast myListHeight01" :class="{disable:!list.length}">
				<Pagination class="ml2x" :pagination="pagination" :getList="_getList"></Pagination>
			</div>
		</div>
	</div>
</template>
<script>
import {getLanguageStr} from '@/util/language'
import * as lib from '@/util/lib.js'
import Help from '@/components/common/Help.vue'
import StatusIco from '@/components/common/ui/StatusIco.vue'
import Pagination from '@/components/common/ui/Pagination.vue'
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading'
import Select from '@/components/common/ui/Select.vue'

import * as deviceApi from '@/api/device/order'
export default {
  name: 'readerRecord',
  components: {StatusIco, Pagination, NoResult, Loading, Select, Help},
  props: {
    deviceId: {
      type: [String, Number],
      default: null
    },
    deviceSn: {
      type: [String, Number],
      default: null
    },
    timezone: {
      type: String,
      default: 'PRC'
    }
  },
  data () {
    return {
      pagination: {}, // 分页数据
      list: [],
      stage,
      floatColumn: ['a'],
      column: ['1', '2', '3', '4', '5', '6'],
      orderProperty: 2,	// 1:order_id,2:create_time,3:update_time
	  orderDirection: 2,	// 1:ASC,2:DESC
	  orderedsc: 'DESC',
      instructionsStatusList: [{value:null, name: getLanguageStr('cmd19', '全部'), def: getLanguageStr('word1513','升级状态')}].concat(lib.getTypeText('', 'deviceOrderStatus', true)),	// 指令状态
      instructionsStatusSelected: ''
    }
  },
  methods: {
    timeFormat: lib.timeFormat,
    getLanguageStr,
    getTypeText: lib.getTypeText,
    show (data) {
      statistic('A68','A6833')
      this._getList()
      lib.fillHeight()
      lib.setScroll($('#updateRecordList [scroll]'))
    },
    order (orderBy) {
      this.orderProperty = orderBy
      if (this.orderDirection === 2) {
		this.orderDirection = 1
		this.orderedsc = "ASC"
      } else {
		this.orderDirection = 2
		this.orderedsc = "DESC"
      }
      this._getList()
    },
    instructionsStatusSelect (index) {
      this.instructionsStatusSelected = this.instructionsStatusList[index].value
      this._getList()
    },
    _getList () {
      this.$refs.loading.show()
      let queryParam = {
            	deviceId: this.deviceId,
            	deviceSn: this.deviceSn,
            	// deviceType: this.deviceType,	// 2:普通设备
            	operationType: 12,	// 12:读取或设置
            	orderType: 2,	// 1:控制指令,2:升级指令
        ascDesc: this.orderDirection,
        orderBy: this.orderProperty,
        status: this.instructionsStatusSelected,
        page: this.pagination.request.page,
        size: this.pagination.request.size,
        isGetVersionInfo: true,
        language: stage.languageId
      }
      deviceApi.updateRecordList(queryParam).then(res => {
            	this.$refs.loading.hide()
            	res.data.map(item => {
            		// item.updateTime = Number(item.updateTime) + mz.tz(this.timeZone)._offset * 60 * 1000
            	})
            	this.list = res.data
        let {total} = res
        this.pagination = {...this.pagination, total}
        this.$refs.loading.hide()

        this.$nextTick(() => {
          lib.fillHeight()
          lib.setScroll($('#updateRecordList [scroll]'))
        })
      }, error => {
        this.$refs.loading.hide()
        !_.isEmpty(error) && this.$notify(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/device/device/part/UpdateRecord.vue